import React from 'react';
import PropTypes from 'prop-types';
import Button from '@Components/Button';

export default class Footer extends React.PureComponent {
  render() {
    const { selfClose, submitAlertFormEnabled, submitAlertForm, isEditMode, isMigrateMode } = this.props;

    return (
      <div className="els-btn-group-right">
        <Button
          buttonConfig={{
            type: 'tertiary',
            size: 'sm',
            label: 'Cancel',
            e2eName: 'create-alert-cancel',
          }}
          iconConfig={{
            name: 'chevron-right',
            size: 'sm',
          }}
          onClick={selfClose}
        />
        <Button
          disabled={!submitAlertFormEnabled}
          buttonConfig={{
            type: 'primary',
            size: 'sm',
            label: isEditMode ? 'Save' : isMigrateMode ? 'Migrate' : 'Create',
            e2eName: 'create-alert-create',
          }}
          iconConfig={{
            name: 'chevron-right',
            size: 'sm',
          }}
          onClick={submitAlertForm}
        />
      </div>
    );
  }
}

Footer.propTypes = {
  selfClose: PropTypes.func.isRequired,
  submitAlertFormEnabled: PropTypes.bool,
  submitAlertForm: PropTypes.func.isRequired,
  isEditMode: PropTypes.bool,
  isMigrateMode: PropTypes.bool,
};
